import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CalendarRefreshService {
  public shouldRefresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/calendar-refresh.service.ts